module.exports = __webpack_public_path__ + "static/img/HZGCLogo.4cf1e33.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/HZGCLogo.png
// module id = 6xz6
// module chunks = 12